import { FormSectionContent } from 'modules/workflowNodeEditors/EditorBody.styled';
import { Banner } from 'ui/banner';
import { BannerVariants, BannerProps } from 'ui/banner/types';

export const SendBanner = (props: BannerProps) => {
  const { variant = BannerVariants.WARNING, ...rest } = props;

  return (
    <FormSectionContent>
      <Banner variant={variant} {...rest} />
    </FormSectionContent>
  );
};
